import Vue from 'vue'
import Axios from 'axios'
import VueRouter from 'vue-router'
import Vuei18n from 'vue-i18n'
import i18nLocales from './i18n'
import routes from './routes'
import VueMaterial from 'vue-material'
import VScrollLock from 'v-scroll-lock'
import VueScrollTo from 'vue-scrollto'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.prototype.$http = Axios
Vue.use(VueRouter)
Vue.use(Vuei18n)
Vue.use(VScrollLock)
Vue.use(VueScrollTo)
Vue.use(VueCookies)

/*** Vue material configuration ***/

Vue.use(VueMaterial)

// change single option
Vue.material.locale.dateFormat = 'dd/MM/yyyy'

// change multiple options
Vue.material = {
  ...Vue.material,
  locale: {
    ...Vue.material.locale,
    dateFormat: 'dd/MM/yyyy',
    firstDayOfAWeek: 1
  }
}

/*** End ***/

export const currentLang = i18nLocales.en
export const i18n = new Vuei18n({
  locale: 'en',
  messages: i18nLocales
})

export const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export const apiServer = process.env.VUE_APP_API_URL.trim()
export const imageServer = process.env.VUE_APP_IMAGE_SERVER.trim()
export const publicPath = process.env.VUE_APP_PUBLIC_PATH.trim()
export const storeUrlFormat = process.env.VUE_APP_STORE_URL.trim()